import { TumourStreamInterface } from "interfaces/templates";

export const getTumourStreamText = (template: {
  tumourStream?: TumourStreamInterface;
  tumourStreams?: TumourStreamInterface[];
}): string => {
  if (template.tumourStreams && template.tumourStreams?.length > 0) {
    return template.tumourStreams.map((stream) => stream.name).join(", ");
  }

  // Legacy tumour stream to be removed
  if (template.tumourStream) {
    return template.tumourStream.name;
  }

  return "";
};
